import { render } from "./Step2.vue?vue&type=template&id=6fc5d0ee&scoped=true&ts=true"
import script from "./Step2.vue?vue&type=script&lang=ts"
export * from "./Step2.vue?vue&type=script&lang=ts"

import "./Step2.vue?vue&type=style&index=0&id=6fc5d0ee&scoped=true&lang=scss"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc5d0ee"]])

export default __exports__